// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"871cabc8","248":"5351a289","260":"3ef59f48","449":"481b7798","496":"6222107d","596":"d2f93930","619":"34bd6d33","821":"444dd838","956":"7f39e1bc"}[chunkId] + ".chunk.js";
};